var buttonReset = "\n  background: transparent;\n  border: none;\n";

export { buttonReset };
